/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useMutation, useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  DataEnvelopeOfWhatsAppDashboardDto,
  DataEnvelopeOfWhatsAppDispatchDetailDto,
  GetWhatsAppDispatchesParams,
  ManageWhatsAppDto,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getWhatsAppDispatches = (
  params?: GetWhatsAppDispatchesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfWhatsAppDashboardDto>(
    { url: `/v1/whatsapp/dispatches`, method: 'GET', params, signal },
    options,
  )
}

export const getGetWhatsAppDispatchesQueryKey = (params?: GetWhatsAppDispatchesParams) => {
  return [`/v1/whatsapp/dispatches`, ...(params ? [params] : [])] as const
}

export const getGetWhatsAppDispatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof getWhatsAppDispatches>>,
  TError = unknown,
>(
  params?: GetWhatsAppDispatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWhatsAppDispatches>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetWhatsAppDispatchesQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWhatsAppDispatches>>> = ({ signal }) =>
    getWhatsAppDispatches(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWhatsAppDispatches>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWhatsAppDispatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWhatsAppDispatches>>
>
export type GetWhatsAppDispatchesQueryError = unknown

export function useGetWhatsAppDispatches<
  TData = Awaited<ReturnType<typeof getWhatsAppDispatches>>,
  TError = unknown,
>(
  params: undefined | GetWhatsAppDispatchesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWhatsAppDispatches>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWhatsAppDispatches>>,
          TError,
          Awaited<ReturnType<typeof getWhatsAppDispatches>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWhatsAppDispatches<
  TData = Awaited<ReturnType<typeof getWhatsAppDispatches>>,
  TError = unknown,
>(
  params?: GetWhatsAppDispatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWhatsAppDispatches>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWhatsAppDispatches>>,
          TError,
          Awaited<ReturnType<typeof getWhatsAppDispatches>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWhatsAppDispatches<
  TData = Awaited<ReturnType<typeof getWhatsAppDispatches>>,
  TError = unknown,
>(
  params?: GetWhatsAppDispatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWhatsAppDispatches>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWhatsAppDispatches<
  TData = Awaited<ReturnType<typeof getWhatsAppDispatches>>,
  TError = unknown,
>(
  params?: GetWhatsAppDispatchesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWhatsAppDispatches>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetWhatsAppDispatchesQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getWhatsAppDispatch = (
  source: string,
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfWhatsAppDispatchDetailDto>(
    { url: `/v1/whatsapp/dispatches/${source}/${id}`, method: 'GET', signal },
    options,
  )
}

export const getGetWhatsAppDispatchQueryKey = (source: string, id: string) => {
  return [`/v1/whatsapp/dispatches/${source}/${id}`] as const
}

export const getGetWhatsAppDispatchQueryOptions = <
  TData = Awaited<ReturnType<typeof getWhatsAppDispatch>>,
  TError = unknown,
>(
  source: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWhatsAppDispatch>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetWhatsAppDispatchQueryKey(source, id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWhatsAppDispatch>>> = ({ signal }) =>
    getWhatsAppDispatch(source, id, requestOptions, signal)

  return {
    queryKey,
    queryFn,
    enabled: source !== null && source !== undefined && id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getWhatsAppDispatch>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetWhatsAppDispatchQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWhatsAppDispatch>>
>
export type GetWhatsAppDispatchQueryError = unknown

export function useGetWhatsAppDispatch<
  TData = Awaited<ReturnType<typeof getWhatsAppDispatch>>,
  TError = unknown,
>(
  source: string,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWhatsAppDispatch>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWhatsAppDispatch>>,
          TError,
          Awaited<ReturnType<typeof getWhatsAppDispatch>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWhatsAppDispatch<
  TData = Awaited<ReturnType<typeof getWhatsAppDispatch>>,
  TError = unknown,
>(
  source: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWhatsAppDispatch>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWhatsAppDispatch>>,
          TError,
          Awaited<ReturnType<typeof getWhatsAppDispatch>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWhatsAppDispatch<
  TData = Awaited<ReturnType<typeof getWhatsAppDispatch>>,
  TError = unknown,
>(
  source: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWhatsAppDispatch>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWhatsAppDispatch<
  TData = Awaited<ReturnType<typeof getWhatsAppDispatch>>,
  TError = unknown,
>(
  source: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWhatsAppDispatch>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetWhatsAppDispatchQueryOptions(source, id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const manageWhatsAppDispatch = (
  source: string,
  id: string,
  manageWhatsAppDto: ManageWhatsAppDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfWhatsAppDispatchDetailDto>(
    {
      url: `/v1/whatsapp/dispatches/${source}/${id}/actions`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: manageWhatsAppDto,
      signal,
    },
    options,
  )
}

export const getManageWhatsAppDispatchMutationKey = () => ['manageWhatsAppDispatch'] as const

export const getManageWhatsAppDispatchMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof manageWhatsAppDispatch>>,
    TError,
    ManageWhatsAppDispatchMutationVariables,
    TContext
  >
  request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
  Awaited<ReturnType<typeof manageWhatsAppDispatch>>,
  TError,
  ManageWhatsAppDispatchMutationVariables,
  TContext
> => {
  const mutationKey = getManageWhatsAppDispatchMutationKey()
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof manageWhatsAppDispatch>>,
    ManageWhatsAppDispatchMutationVariables
  > = (props) => {
    const { source, id, data } = props ?? {}

    return manageWhatsAppDispatch(source, id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type ManageWhatsAppDispatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof manageWhatsAppDispatch>>
>
export type ManageWhatsAppDispatchMutationBody = ManageWhatsAppDto
export type ManageWhatsAppDispatchMutationError = unknown
export type ManageWhatsAppDispatchMutationVariables = {
  source: string
  id: string
  data: ManageWhatsAppDto
}

export const useManageWhatsAppDispatch = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof manageWhatsAppDispatch>>,
      TError,
      ManageWhatsAppDispatchMutationVariables,
      TContext
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof manageWhatsAppDispatch>>,
  TError,
  ManageWhatsAppDispatchMutationVariables,
  TContext
> => {
  return useMutation(getManageWhatsAppDispatchMutationOptions(options), queryClient)
}
